import { computed, Injectable, Signal, WritableSignal } from '@angular/core';
import { PanelHeader, PanelState } from './panel';

interface PanelStateManager {
  (): PanelState;
  update: WritableSignal<PanelState>['update'];
}

@Injectable()
export class Panel {
  private _stateManager!: PanelStateManager;
  readonly $state: Signal<PanelState> = computed(() => this._stateManager());

  /**
   * @description Initialize the shared "state" manager for this OkePanel component
   * @param stateManager **linkedSignal<OkePanel>** "state" manager
   */
  initState(linkedSignal: WritableSignal<PanelState>): void {
    if (this._stateManager) {
      return;
    }
    this._stateManager = linkedSignal;
  }

  /**
   * @description Method by which the shared "state" for this specific component
   *   instance is updated
   * @param stateKeyToUpdate The state manager key to update
   * @param updatedStateVal The partial value for the updated state key
   */
  updateState(stateKeyToUpdate: 'header', updatedStateVal: Partial<PanelHeader>): void;
  updateState(stateKeyToUpdate: 'collapsible', updatedStateVal: Partial<PanelState['collapsible']>): void;
  updateState(
    stateKeyToUpdate: keyof PanelState,
    updatedStateVal: Partial<PanelHeader> | Partial<PanelState['collapsible']>
  ): void {
    this._stateManager.update(state => {
      const updatedState = structuredClone(state);
      if (stateKeyToUpdate === 'header') {
        Object.assign(updatedState.header, updatedStateVal);
      } else {
        Object.assign(updatedState.collapsible, updatedStateVal);
      }
      return updatedState;
    });
  }
}
